import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationRunLogsDeleteArgs, Run } from "types/generated";

type FetchRunLogsDeleteData = { runLogsDelete: Pick<Run, "id"> };

export const RUN_LOGS_DELETE: TypedDocumentNode<FetchRunLogsDeleteData, MutationRunLogsDeleteArgs> =
  gql`
    mutation DeleteRunLogs($stack: ID!, $run: ID!) {
      runLogsDelete(stack: $stack, run: $run) {
        id
      }
    }
  `;
